// removed by extract-text-webpack-plugin
module.exports = {"tagSelect":"antd-pro_-_-scaffold-src-components-TagSelect-tagSelect","expand":"antd-pro_-_-scaffold-src-components-TagSelect-expand","fold":"antd-pro_-_-scaffold-src-components-TagSelect-fold","trigger":"antd-pro_-_-scaffold-src-components-TagSelect-trigger","expandTag":"antd-pro_-_-scaffold-src-components-TagSelect-expandTag"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/TagSelect/index.less
// module id = 440
// module chunks = 0 1